import { ApiService } from "src/network/apiService";

export interface IMobileAppConfigDownloadResponse {
    iOSFileUrl: string;
    androidFileUrl: string;
}

export interface IContactCenterConfigDownloadResponse {
    configUrl: string;
}

export interface ISecretDispatchResponse {
    recipientNames: string[];
}

export class ApplicationDownloadsViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async getUrlsToDownloadAppConfigsAsync(mobileApplicationId: string): Promise<{ result?: IMobileAppConfigDownloadResponse; error?: string }> {

        const url = `/onboard/credentials/device/${mobileApplicationId}/config`
        const response: any = await this.apiService.getAsync(url);

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                console.log(`success`);
                const responseData = response.scResponse.data;
                console.log(`data - ${JSON.stringify(responseData)}`);

                return { result: { iOSFileUrl: responseData.iOSFile, androidFileUrl: responseData.androidFile } };
            } else {
                return {
                    result: undefined,
                    error: response.scResponse?.message,
                };
            }
        }

        return { result: undefined, error: "response not returned" }

    }

    async getUrlsToDownloadContactCenterConfigsAsync(contactCenterId: string): Promise<{ result?: IContactCenterConfigDownloadResponse; error?: string }> {

        const url = `/onboard/credentials/cc/${contactCenterId}/config`
        const response: any = await this.apiService.getAsync(url);

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                console.log(`success`);
                const responseData = response.scResponse.data;
                console.log(`data - ${JSON.stringify(responseData)}`);

                return { result: { configUrl: responseData } };
            } else {
                return {
                    result: undefined,
                    error: response.scResponse?.message,
                };
            }
        }

        return { result: undefined, error: "response not returned" }

    }

    async dispatchSecret(
        type: "MobileApp" | "ContactCenter",
        businessId: string,
        applicationOrContactCenterId: string
    ): Promise<{ result?: ISecretDispatchResponse; error?: string }> {
        // Construct the URL dynamically based on the type
        const url =
            type === "MobileApp"
                ? `/onboard/credentials/device/${applicationOrContactCenterId}/secret?businessId=${businessId}`
                : `/onboard/credentials/cc/${applicationOrContactCenterId}/secret?businessId=${businessId}`;

        try {
            // Make the API call
            const response: any = await this.apiService.postAsync(url, undefined);

            if (response) {
                if (response.scResponse && response.scResponse.code === 2000) {
                    console.log(`Success`);
                    const responseData = response.scResponse.data;
                    console.log(`Data - ${JSON.stringify(responseData)}`);

                    return { result: { recipientNames: responseData } };
                } else {
                    return {
                        result: undefined,
                        error: response.scResponse?.message,
                    };
                }
            }

            return { result: undefined, error: "response not returned" };
        } catch (error) {
            console.error("Error dispatching secret:", error);
            return { result: undefined, error: "An unexpected error occurred" };
        }
    }
}